import React from 'react';
import EditableText from '../EditableText';

function Hero({ hero, setHero }) {
  return (
    <section className="hero" id="home">
      <div className="hero-names-container">
        <EditableText
          value={hero.names}
          onChange={val => setHero({ ...hero, names: val })}
          className="hero-name"
          tag="div"
          multiline={true}
          html={true}
        />
      </div>
      <EditableText value={hero.text} onChange={val => setHero({ ...hero, text: val })} className="hero-text" html={true} />
      <div className="venue-sketch-container">
        <img src="/venue-sketch.jpg" alt="Villa Bella Vista" className="venue-sketch-accent" />
      </div>
    </section>
  );
}

export default Hero;
